import { BASE_URL_BR, BASE_URL_LATAM, REFERRER_STRIP_REGEX } from './constants';

export function stripReferrerAndUtmTags(url: string): string {
  return url.split(REFERRER_STRIP_REGEX)[0] ?? url;
}

export function getSelectedCountryPath(
  hostname: string,
  pathname: string,
  supportCountries: string[],
): string {
  const isBr = hostname.includes('.com.br');
  if (isBr) return '';
  const pathParts = pathname.split('/').filter(Boolean);
  if (pathParts.length >= 1 && supportCountries.includes(pathParts[0])) {
    return '/' + pathParts[0];
  }
  return '';
}

export function buildTrackUrl(baseUrl: string, selectedCountry: string): string {
  const path = (selectedCountry || '') + '/track';
  const base = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/';
  return new URL(path, base).toString();
}

export function getBaseUrlFromHost(hostname: string): string {
  return hostname.includes('.com.br') ? BASE_URL_BR : BASE_URL_LATAM;
}
